// extracted by mini-css-extract-plugin
export var centered = "TeamMembers-module--centered--69ff3";
export var close = "TeamMembers-module--close--e2e01";
export var container = "TeamMembers-module--container--f9166";
export var employee = "TeamMembers-module--employee--86580";
export var employeeEntry = "TeamMembers-module--employee-entry--ca703";
export var grid = "TeamMembers-module--grid--0a2cd";
export var hr = "TeamMembers-module--hr--39c6b";
export var image = "TeamMembers-module--image--28f46";
export var imageWrapper = "TeamMembers-module--image-wrapper--4e6b1";
export var medicalExpert = "TeamMembers-module--medical-expert--c7a3e";
export var medicalExpertEntry = "TeamMembers-module--medical-expert-entry--9e42d";
export var medicalExpertImage = "TeamMembers-module--medical-expert-image--fcd53";
export var modal = "TeamMembers-module--modal--f3518";
export var modalHeader = "TeamMembers-module--modal-header--a7f24";
export var modalText = "TeamMembers-module--modal-text--3620b";
export var modalWrapper = "TeamMembers-module--modal-wrapper--a51ba";
export var name = "TeamMembers-module--name--7ee4d";
export var role = "TeamMembers-module--role--9a0f6";
export var root = "TeamMembers-module--root--1f3f1";
export var showAll = "TeamMembers-module--show-all--fb559";
export var showMoreButton = "TeamMembers-module--show-more-button--b3319";
export var swiper = "TeamMembers-module--swiper--f0dc9";
export var swiperSlide = "TeamMembers-module--swiper-slide--2210e";
export var swiperWrapper = "TeamMembers-module--swiper-wrapper--ca5d0";
export var title = "TeamMembers-module--title--aab01";
export var vetSchool = "TeamMembers-module--vetSchool--2d65f";